import { render, staticRenderFns } from "./UpdateCustomerName.vue?vue&type=template&id=d5dfa3de&scoped=true"
import script from "./UpdateCustomerName.vue?vue&type=script&lang=js"
export * from "./UpdateCustomerName.vue?vue&type=script&lang=js"
import style0 from "./UpdateCustomerName.vue?vue&type=style&index=0&id=d5dfa3de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5dfa3de",
  null
  
)

export default component.exports